import script from "./BaPermissions.vue?vue&type=script&setup=true&lang=js"
export * from "./BaPermissions.vue?vue&type=script&setup=true&lang=js"

import "./BaPermissions.vue?vue&type=style&index=0&id=a476a8a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a476a8a0"]])

export default __exports__